<template>
  <div class="columns is-centered">
    <div class="column is-7">
      <h1 class="is-size-jumbo page-title"><span class="accent">Hotter </span>the Weather</h1>
      <h2 class="is-size-jumbo"><span class="has-text-weight-bold">Cooler the <span class="accent">Cash!</span></span></h2>
      <p>Get assured Paytm cash with your favourite Cavin’s Lassi this summer. The hotter your city, the more the Paytm cash you get. </p>
      <br>
      <ul class="bullet-list list">
        <li><span class="prefix">1</span><span>Scan the QR code on your Cavin’s Lassi pack</span></li>
        <li><span class="prefix">2</span><span>‘Allow’ location access</span></li>
        <li><span class="prefix">3</span><span>Complete registration and enter OTP</span></li>
        <li><span class="prefix">4</span><span>Redeem your hot Paytm cash while sipping your cool Cavin’s lassi!</span></li>
      </ul>
    </div>
    <div class="column is-5">
      <div class="box is-danger" style="background-color: #db2559;">
        <template v-if="!showOTP">
          <h1 class="title">Register Here</h1>
          <p class="help" v-if="formErrors.length > 0">Error: {{formErrors}}</p>
          <form action="" @submit.prevent novalidate>
            <div class="field">
              <input type="text" placeholder="Your Name" class="input"
              v-model="newUser.customername" />
              <p class="help" v-if="formErrors.customername">{{formErrors.customername[0]}}</p>
            </div>
            <div class="field">
              <input type="text" placeholder="Your Email" class="input"
              v-model="newUser.email" />
              <p class="help" v-if="formErrors.email">{{formErrors.email[0]}}</p>
            </div>
            <div class="field">
              <input type="text" placeholder="Your Phone Number" class="input"
              v-model="newUser.mobile" />
              <p class="help" v-if="formErrors.mobile">{{formErrors.mobile[0]}}</p>
            </div>
            <div class="field">
              <label class="label">
                <input type="checkbox" class="checkbox" v-model="newUser.ackChecked">
                <span class="has-text-white is-size-7">I Agree to the <a>Terms and Conditions</a></span>
              </label>
              <p class="help" v-if="TnCError">You must agree to the terms and conditions to proceed</p>
            </div>
            <button @click="handleRegister" :class="registerButtonClassNames">Locate Me and Proceed</button>
          </form>
        </template>
        <template v-else>
          <div class="header">
            <h1 class="title">Complete Registration</h1>
            <p>An OTP has been sent to your registered mobile number. Please enter the OTP below </p>
          </div>
          <div class="field">
            <input type="number" class="input" placeholder="Enter OTP" v-model="validateOTP.otp">
            <p v-if="validateOTPErrors" class="help">{{validateOTPErrors}}</p>
            <p v-if="!resendOTP" class="is-size-7">Haven’t received your OTP yet?<a @click.prevent="handleResendOTP">Click here to regenerate OTP</a></p>
            <p v-else class="is-size-7">OTP Resent to your registered number</p>
          </div>
          <button @click="handleProceed" :class="validateOTPButtonClassNames">Submit</button>
        </template>
    </div>
  </div>
  </div>
</template>

<script>
import API from "../API";
import axios from "axios";
import { MAPS_API_KEY } from "../constants.js";
import { DeviceUUID } from "device-uuid";
import Raven from "raven-js";
import isWebView from "is-ua-webview";

export default {
  name: "HelloWorld",
  created() {
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("offerData");
  },
  data() {
    return {
      showOTP: false,
      resendOTP: false,
      formErrors: {},
      TnCError: false,
      newUser: {
        customername: "",
        email: "",
        mobile: "",
        lat: "",
        lng: "",
        ackChecked: false,
        uuid: new DeviceUUID().get(),
        ref_url: document.referrer || "Direct",
        isWebView: isWebView(window.navigator.userAgent),
        registerLocation: window.location.origin
      },
      registerButtonClassNames: {
        button: true,
        "is-fullwidth": true,
        "is-warning": true,
        "is-loading": false
      },
      validateOTPButtonClassNames: {
        button: true,
        "is-fullwidth": true,
        "is-warning": true,
        "is-loading": false
      },
      validateOTP: {
        customer_id: 1,
        mobile: "",
        otp: ""
      },
      validateOTPErrors: ""
    };
  },
  methods: {
    getGeoLocation() {
      if ("geolocation" in navigator) {
        return new Promise(function(resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
      } else {
        this.$router.push({
          name: "Error",
          params: {
            title: "Browser Unsupported",
            message:
              "We're sorry but the browser you are using does not support location services",
            errorText: err.message
          }
        });
      }
    },
    postRegister() {
      API.post("/registration", this.newUser)
        .then(res => {
          // Early Exit to WebView Error
          if (res.data.data.link) {
            this.$router.push({
              name: "Error",
              params: {
                title: "SMS Sent",
                message:
                  "We've detected an embedded browser ( Web View ), <b>we've sent you an SMS with a unique link to access this site on a Standalone Browser</b>"
              }
            });
          }
          let user = sessionStorage.setItem(
            "userData",
            JSON.stringify(res.data.data)
          );
          this.validateOTP.customer_id = res.data.data.customer_id;
          this.validateOTP.access_token = res.data.data.access_token;
          this.validateOTP.mobile = this.newUser.mobile;
          this.registerButtonClassNames["is-loading"] = false;
          this.showOTP = true;
        })
        .catch(err => {
          this.registerButtonClassNames["is-loading"] = false;
          this.formErrors = JSON.parse(err.response.data.data.message);
          Raven.captureException(err);
        });
    },
    handleRegister() {
      if (this.newUser.ackChecked != true) {
        this.TnCError = true;
        return;
      }
      this.registerButtonClassNames["is-loading"] = true;
      if (this.newUser.isWebView) {
        this.postRegister();
      } else {
        this.getGeoLocation()
          .then(position => {
            this.newUser.lat = String(position.coords.latitude);
            this.newUser.lng = String(position.coords.longitude);
            this.postRegister();
          })
          .catch(err => {
            Raven.captureException(err);
            this.$router.push({
              name: "Error",
              params: {
                title: "Location Unavailable",
                message:
                  "Please Allow Location and <a class='has-text-white is-link' href='/'>click here</a> to try again",
                errorText: err.message
              }
            });
          });
      }
    },
    handleProceed() {
      this.validateOTPButtonClassNames["is-loading"] = true;
      API.post("/validateotp", this.validateOTP)
        .then(res => {
          sessionStorage.setItem("offerData", JSON.stringify(res.data.data));
          this.$router.push({ name: "Claim" });
        })
        .catch(err => {
          this.validateOTPButtonClassNames["is-loading"] = false;
          this.validateOTPErrors = JSON.parse(err.response.data.data.message);
        });
    },
    handleResendOTP() {
      API.post("/resendotp", {
        customer_id: this.validateOTP.customer_id,
        access_token: this.validateOTP.access_token,
        mobile: this.validateOTP.mobile
      }).then(res => (this.resendOTP = true));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.prefix {
  display: inline-block;
  height: 1rem;
  width: 1rem;
  background-color: white;
  border-radius: 50%;
  color: black;
  font-size: 0.8rem;
  text-align: center;
  line-height: 1rem;
  margin-right: 0.25rem;
}

.box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.field:not(:last-child) {
  margin: 0.75rem 0;
}

.accent {
  color: #ffc800;
}
.title {
  color: #fff;
}

.list li {
  font-size: 14px;
  @media screen and (min-width: 420px) {
    font-size: 1rem;
  }
}

.bullet-list {
  padding-left: 1rem;
  .prefix {
    margin-left: -1rem;
  }
}

.loader.is-centered {
  margin: 0 auto;
}
.loader {
  height: 2.5rem;
  width: 2.5rem;
  border-width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue